<template>
  <div class="contact-us flex-box">
    <div class="content-top">
      <div class="title">联系我们</div>
      <div class="description">合作，从沟通开始。期待您的联系</div>
    </div>
    <div class="content-bottom"></div>
    <div class="content-middle">
      <div class="qipao1"></div>
      <div class="qipao2"></div>
      <div class="middle-left">
        <div class="sub-title">公司地址</div>
        <div class="content-item"><img :src="gywm1" alt=""><div><span>苏州：</span>苏州工业园区独墅湖数字经济产业园B3栋10层</div></div>
        <div class="content-item"><img :src="gywm2" alt=""><div><span>北京：</span>北京市海淀区紫竹院路98号化工大学科技园312</div></div>
        <div class="content-item"><img :src="gywm3" alt=""><div><span>武汉：</span>武汉市东湖高新区高新大道668号光谷金融中心A座11层</div></div>
        <div class="content-item"><img :src="gywm4" alt=""><div><span>深圳：</span>深圳市宝安区西乡街道固戍一路置富广场2楼</div></div>
        <div class="content-item"><img :src="gywm4" alt=""><div><span>东莞：</span>广东省东莞市松山湖园区总部二路9号1栋2单元706室</div></div>
      </div>
      
      <div class="middle-right">
        
        <div class="sub-title">璞华集团</div>
        <div class="heng-gang"></div>
        <div class="content-item"><img :src="gywm5" alt=""><div><span>免费电话：</span>4006-160-730</div></div>
        <div class="content-item"><img :src="gywm6" alt=""><div><span>业务邮箱地址：</span>service@purvar.com</div></div>
        <div class="content-item"><img :src="gywm6" alt=""><div><span>投诉邮箱地址：</span>tousu@purvar.com</div></div>
      </div>
      <div class="fenge"></div>
      <img :src="youxia1" alt="" class="youxia-bj">
    </div>
    
  </div>
</template>
<script>
import gywm1 from '@/assets/images/gywm1.png'
import gywm2 from '@/assets/images/gywm2.png'
import gywm3 from '@/assets/images/gywm3.png'
import gywm4 from '@/assets/images/gywm4.png'
import gywm5 from '@/assets/images/gywm5.png'
import gywm6 from '@/assets/images/gywm6.png'
import youxia1 from '@/assets/images/youxia1.png'

export default {
  props: {
   
  },
  data() {
    return {
      gywm1,
      gywm2,
      gywm3,
      gywm4,
      gywm5,
      gywm6,
      youxia1
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
   
  }
}
</script>

<style lang="scss" scoped>
$img: "../../assets/images";

.contact-us {
  flex-direction: column;
  align-items: center;
  background: linear-gradient( 152deg, #FBFDFF 0%, #EAF4FF 100%);
  position: relative;
  .content-top {
    text-align: center;
    width: 100%;
    height: 51.5rem;
    padding-top: 9rem;
    .title {
      font-size: 4rem;
      font-weight: 600;
      color: #333333;
      line-height: 4rem;
      margin-bottom: 2.4rem;
    }

    .description {
      font-size: 1.8rem;
      font-weight: 400;
      color: #666A77;
      line-height: 1.8rem;
      margin-bottom: 4.2rem;
    }
  }
  .content-bottom {
    width: 192rem;
    height: 25.8rem;
    background: linear-gradient( 318deg, #0F81F4 0%, #37A4FF 100%);
    opacity: 0.8;
  }
  .content-middle {
    position: absolute;
    top: 22rem;
    left: 26rem;
    width: 140rem;
    height: 44rem;
    background: #FFFFFF;
    box-shadow: 0rem 0.5rem 4rem 0rem #D6E2E2;
    padding: 7rem 10rem;
    border-radius: 1.5rem;
    .youxia-bj {
      position: absolute;
      width: 27.6rem;
      height: 15rem;
      right: 0;
      bottom: 0;
    }
    .qipao1 {
      position: absolute;
      width: 4.8rem;
      height: 4.8rem;
      background: linear-gradient(161deg, #A1D1FF 0%, #72BCFB 36%, #1F96F3 100%);
      opacity: 0.16;
      top: 4.5rem;
      right: 41rem;
      border-radius: 50%;
    }
    .qipao2 {
      width: 2.5rem;
      height: 2.5rem;
      background: #3674FE;
      border-radius: 50%;
      opacity: 0.04;
      position: absolute;

      top: 2.5rem;
      right: 38rem;
    }
    .content-item {
      display: flex;
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 1.8rem;
      img {
        width: 4rem;
        height: 4rem;
        border-radius: 50%;
        flex-shrink: 0;
      }
      div {
        flex: 1;
        min-width: 0;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 1.8rem;
        color: #333333;
        line-height: 2.2rem;
        text-align: left;
        font-style: normal;
        margin-left: 1.6rem;
        font-weight: bold;
        padding-top: 0.9rem;
        white-space: normal;
        word-break: break-word;
        span {
          font-weight: 400;
        }
      }
    }

    .middle-left {
      height: 100%;
      float: left;
      .sub-title {
        height: 2.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 2.4rem;
        color: #333333;
        line-height: 2.4rem;
        text-align: left;
        font-style: normal;
        margin-bottom: 2.7rem;
      }
    }
    .fenge {
      width: 0.1rem;
      height: 28.1rem;
      border: 0.1rem dashed #EAF4FF;
      margin-right: 9rem;
      float: right;
    }
    .middle-right {
      width: 45rem;
      height: 100%;
      float: right;
      .sub-title {
        height: 2.8rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 600;
        font-size: 2.8rem;
        color: #333333;
        line-height: 2.8rem;
        text-align: left;
        font-style: normal;
      }
      .heng-gang {
        width: 4.8rem;
        height: 0.6rem;
        background: #2372FF;
        border-radius: 0.3rem;
        margin-top: 1.6rem;
        margin-bottom: .4rem;
      }
      .content-item {
        margin-top: 3.5rem;
      }
    }
  }
}

@import "@/styles/mixins.scss";

@include mobile {
  .contact-us {
    .content-top {
      height: auto;
      padding: 4.8rem 1.6rem 2.4rem;
      .title {
        font-size: 2.4rem;
        line-height: 3.2rem;
      }
      .description {
        font-size: 1.4rem;
        line-height: 2.2rem;
        margin-bottom: 0;
      }
    }
    .content-bottom {
      display: none;
    }
    .content-middle {
      position: relative;
      top: auto;
      left: auto;
      width: calc(100% - 3.2rem);
      height: auto;
      margin: 0 auto 2.4rem;
      padding: 2.4rem 1.6rem;
      .fenge,
      .youxia-bj {
        display: none;
      }
      .middle-left,
      .middle-right {
        float: none;
        width: 100%;
        height: auto;
      }
      .content-item {
        align-items: flex-start;
        img {
          width: 3.6rem;
          height: 3.6rem;
        }
        div {
          font-size: 1.4rem;
          line-height: 2rem;
          padding-top: 0.8rem;
        }
      }
    }
  }
}
</style>
